export const topmenu = {
  account: "Customer Account",
  homes: "Homes",
  users: "Users",
  staff: "Staff",
  overview: "Overview",
  awards: "Awards",
  statistics: "Statistics",
  calendar: "Calendar",

  access_level_super_admin: "Super",
  access_level_account_admin: "Authorization 1",
  access_level_operations_manager: "Authorization 2",
  access_level_home_manager: "Authorization 3",
  logged_in_with: "Logged in with ",
};
